import { render, staticRenderFns } from "./ChangeAppUserDetails.modal.vue?vue&type=template&id=16383708&"
import script from "./ChangeAppUserDetails.modal.vue?vue&type=script&lang=ts&"
export * from "./ChangeAppUserDetails.modal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeAppUserDetails.modal.vue?vue&type=style&index=0&id=16383708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports